import api from './api';
import { posService, POSProduct } from './posService';

export interface Product {
  id: number;
  name: string;
  code: string;
  dosage_form: string;
  strength: string;
  unit: string;
  price: number;
  available_stock: number;
  min_stock_level: number;
  category_name?: string;
  manufacturer?: string;
  expiry_date?: string;
}

export const productService = {
  // Lấy danh sách sản phẩm
  getProducts: async (params?: any): Promise<{ data: Product[]; total: number }> => {
    try {
      const products = await posService.searchProducts('');
      return {
        data: products as Product[],
        total: products.length
      };
    } catch (error) {
      console.error('Error getting products:', error);
      throw error;
    }
  },

  // Tìm kiếm sản phẩm
  searchProducts: async (query: string): Promise<Product[]> => {
    try {
      const products = await posService.searchProducts(query);
      return products as Product[];
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  },

  // Lấy thông tin tồn kho chi tiết
  getProductStock: async (productId: number): Promise<any[]> => {
    try {
      const stock = await posService.getProductStock(productId);
      return stock;
    } catch (error) {
      console.error('Error getting product stock:', error);
      throw error;
    }
  }
};